import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CartStorageService {
  arrayPackageStoreLocal: any[] = [];
  numberCart: number = 0;
  constructor() { }

  //lưu vào local storage.
  saveLocalStorage(array: any) {
    localStorage.setItem('arrayPackageStoreLocal', JSON.stringify(array));
  }

  //Lấy số lượng trong giỏ.
  getNumberOfItemInCart() {
    this.numberCart = 0;
    const arrData = localStorage.getItem('arrayPackageStoreLocal');
    if (arrData !== null && arrData !== undefined) {
      JSON.parse(arrData).forEach(x => {
        this.numberCart = this.numberCart + x.quantityOrder;
      });
      return this.numberCart;
    }
    else
      return 0;
  }

  //Lấy list trong giỏ.
  getListInCart() {
    this.arrayPackageStoreLocal = JSON.parse(localStorage.getItem('arrayPackageStoreLocal')) || [];
    return this.arrayPackageStoreLocal;
  }
}
